(() => {
  const root = document.querySelector('[data-article]');
  const body = root && root.querySelector('[data-article-body]');
  if (!body) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const SHOW_DELAY = 350;
  const HIDE_DELAY = 200;
  const cache = new Map();
  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  const money = new Intl.NumberFormat(undefined, { style: 'currency', currency });
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const esc = (s) =>
    String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  let card = null;
  let showTimer = 0;
  let hideTimer = 0;
  let hoverLink = null;
  let activeLink = null;
  let controller = null;

  const buildCard = () => {
    const el = document.createElement('div');
    el.className = 'hovercard';
    el.setAttribute('role', 'dialog');
    el.hidden = true;
    el.addEventListener('mouseenter', () => clearTimeout(hideTimer));
    el.addEventListener('mouseleave', scheduleHide);
    document.body.appendChild(el);
    return el;
  };

  const productPath = (href) => {
    try {
      const u = new URL(href, location.origin);
      const m = u.pathname.match(/^(.*\/products\/[^/?#]+)/);
      return m ? m[1] : null;
    } catch (e) {
      return null;
    }
  };

  const fetchProduct = (path) => {
    if (cache.has(path)) return Promise.resolve(cache.get(path));
    controller = new AbortController();
    const p = fetch(`${path}.js`, { signal: controller.signal })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        cache.set(path, data);
        return data;
      })
      .catch(() => {
        cache.delete(path);
        return null;
      });
    cache.set(path, p);
    return p;
  };

  const render = (el, d, href) => {
    let price;
    if (d.price_varies) {
      price = `From ${money.format(d.price_min / 100)}`;
    } else if (d.compare_at_price > d.price) {
      price = `${money.format(d.price / 100)} <del>${money.format(d.compare_at_price / 100)}</del>`;
    } else {
      price = money.format(d.price / 100);
    }
    const media = d.featured_image
      ? `<span class="hovercard__media"><img src="${esc(d.featured_image)}&width=640" alt="" loading="lazy"></span>`
      : '';
    const desc = (d.description || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    el.innerHTML =
      `<a class="hovercard__link" href="${esc(href)}">${media}` +
      `<span class="hovercard__body">` +
      `<span class="hovercard__title">${esc(d.title)}</span>` +
      `<span class="hovercard__price">${price}</span>` +
      (desc ? `<span class="hovercard__desc">${esc(desc)}</span>` : '') +
      `</span></a>`;
  };

  const place = (el, link) => {
    el.hidden = false;
    const r = link.getBoundingClientRect();
    const cw = el.offsetWidth;
    const ch = el.offsetHeight;
    const left = Math.min(Math.max(8, r.left), window.innerWidth - cw - 8);
    let top = r.bottom + 8;
    if (top + ch > window.innerHeight - 8 && r.top - ch - 8 > 8) top = r.top - ch - 8;
    el.style.left = `${left}px`;
    el.style.top = `${top}px`;
  };

  const show = (link) => {
    const path = productPath(link.getAttribute('href'));
    if (!path) return;
    activeLink = link;
    fetchProduct(path).then((d) => {
      if (!d || activeLink !== link) return;
      if (!card) card = buildCard();
      render(card, d, link.href);
      place(card, link);
      requestAnimationFrame(() => card.classList.add('is-visible'));
    });
  };

  const hide = () => {
    activeLink = null;
    if (controller) {
      try { controller.abort(); } catch (e) {}
    }
    if (card) {
      card.classList.remove('is-visible');
      setTimeout(() => {
        if (card && !card.classList.contains('is-visible')) card.hidden = true;
      }, reduce ? 0 : 160);
    }
  };

  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, HIDE_DELAY);
  }

  body.addEventListener('mouseover', (e) => {
    const link = e.target.closest('a[href*="/products/"]');
    if (!link || !body.contains(link) || link === hoverLink) return;
    hoverLink = link;
    clearTimeout(hideTimer);
    clearTimeout(showTimer);
    showTimer = setTimeout(() => show(link), SHOW_DELAY);
  });

  body.addEventListener('mouseout', (e) => {
    const link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    if (e.relatedTarget && link.contains(e.relatedTarget)) return;
    hoverLink = null;
    clearTimeout(showTimer);
    scheduleHide();
  });

  body.addEventListener('focusin', (e) => {
    const link = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (link && body.contains(link)) show(link);
  });
  body.addEventListener('focusout', scheduleHide);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') hide();
  });
  window.addEventListener('scroll', hide, { passive: true });
})();
